import * as RadixDialog from '@radix-ui/react-dialog'
import { FC, PropsWithChildren } from 'react'
import { ModalContext } from './ModalContext'
import { Body, Close, Content, Footer, Header, Overlay, Portal } from './primitives'
import { ModalProps } from './types/modal'

/**
 * Exports the related components to construct a modal. The modal is
 * enforced as controlled with the isOpen and onClose props.
 */
const Root: FC<PropsWithChildren<ModalProps>> = ({ isOpen, onClose, children }) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return (
    <ModalContext.Provider value={{ isOpen, onClose }}>
      <RadixDialog.Root open={isOpen} defaultOpen={isOpen} onOpenChange={handleOpenChange}>
        {children}
      </RadixDialog.Root>
    </ModalContext.Provider>
  )
}

export const Modal = { Root, Portal, Overlay, Header, Body, Close, Footer, Content }
